<template>
    <div>
        <div class="panel-control flex-column flex-fill" :class="[isRecordMode ? 'd-none' : 'd-flex' ]">
            <div class="panel-control-content d-flex flex-column flex-fill">
                <div class="row mb-3">
                    <div class="col-12">
                        <div class="btn-toolbar w-100 justify-content-center" role="toolbar" aria-label="">
                            <div class="btn-group btn-block" role="group" aria-label="Actions">
                                <button
                                    v-for="(action, key) in activeActions"
                                    :key="key"
                                    :title="action.title"
                                    @click.prevent="applyAction(key, $event)"
                                    type="button"
                                    class="btn btn-main min-w-auto mx-0"
                                    :class="{'d-flex align-items-center justify-content-center': !!action.image}"
                                    data-toggle="tooltip-city"
                                >
                                    <template v-if="action.icon">
                                        <i class="" :class="action.icon"></i>
                                    </template>
                                    <template v-else-if="action.image">
                                        <img :src="action.image" class="btn-image" />
                                    </template>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row flex-fill">
                    <div class="col">
                        <div class="annotations-grid" v-if="hasRecords">
                            <div class="record-grid container-fluid">
                                <div class="row">
                                    <record-grid-item
                                        v-for="(item, idx) in recordList"
                                        :key="`record-${idx}`"
                                        :moduleCode="moduleCode"
                                        :record="item"
                                        :map="map"
                                        :zoomToCollection="zoomToCollection"
                                        :showHideCollection="showHideCollection"
                                        @geometryHighlight="onGeometryHighlight"
                                        @changeRecord="onChangeRecord"
                                        @zoomToRecord="onZoomToRecord"
                                        @selectedRecord="onSelectedRecord"/>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <span class="d-block text-center">{{ txtNoAnnotations }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-control d-flex flex-column flex-fill" v-if="isRecordMode">
            <div class="panel-control-content d-flex flex-column flex-fill">
                 <record-item
                    ref="RecordItem"
                    :record="selectedRecord"
                    :moduleCode="moduleCode"
                    :reset="reset"
                    :map="map"
                    :readonlyFormItem="readonlyFormItem"
                    :txtConfirmLeaveSession="txtConfirmLeaveSession"
                    @geometryHighlight="onGeometryHighlight"
                    @update="onChangeRecord"
                    @delete="onDeleteRecord"
                    @download="onExportRecord"
                    @save="onSaveRecord"
                    @back="onBackRecord" />
            </div>
        </div>
        <import-file
            ref="ModalImport"
            v-if="actions.import.active"
            :title="actions.import.title"
            :txtImport="importFile.message"
            :allowedFileTypes="importFile.allowedFileTypes"
            :fileValidation="fileValidation"
            @imported="onImportedFile">
            <div class="d-flex">
                <div class="m-3 flex-grow-1">
                    <div class="form-check city-form-check">
                        <input class="form-check-input"
                            type="checkbox"
                            v-model="importFile.replace"
                            :id="`cb-replace-annotations`"
                            :name="`replace-annotations`">
                        <label class="form-check-label" :for="`cb-replace-annotations`">
                            {{ txtReplaceAnnotations }}
                        </label>
                    </div>
                </div>
            </div>

        </import-file>
    </div>
</template>

<script>
    import AnnotationGridMixin from './../AnnotationGridMixin';

    export default {
        name: 'AnnotationRecordGrid',
        mixins: [
            AnnotationGridMixin,
        ],
        components: {
            RecordGridItem: () => import(/* webpackChunkName: "annotation-record-grid-item" */ './AnnotationRecordGridItem'),
            RecordItem: () => import(/* webpackChunkName: "annotation-record-item" */ './AnnotationRecordItem'),
            ImportFile: () => import(/* webpackChunkName: "annotation-import-file" */ './ModalImportFile'),
        },
        props: {
            moduleCode: {
                type: String,
                require: true,
            },
            map: {
                type: Object,
                default: () => {},
                require: true,
            },
            url: {
                type: Object,
                default: () => {},
            },
            reset: {
                type: Boolean,
                default: false,
            },
            annotationsObject: {
                type: Object,
                required: false,
                default: () => {},
            },
            zoomToCollection: {
                type: Boolean,
                default: true,
            },
            showHideCollection: {
                type: Boolean,
                default: true,
            },
            readonlyFormItem: {
                type: Boolean,
                default: true,
            },
            txtNoAnnotations: {
                type: String,
                default: 'Sem anotações, click no botão [+] para adicionar anotações',
            },
            txtReplaceAnnotations: {
                type: String,
                default: 'Substituir anotações',
            },
            txtConfirmLeaveSession: {
                type: String,
                default: 'Deseja abandonar a sessão de edição da anotação?',
            },
        },
        data() {
            const idPanel = 'annotations';
            return {
                idPanel: idPanel,
                annotations: {},
                selectedRecord: null,
                importFile: {
                    //'Drop your file here or click to select the annotation file to import.</br>(supported files: JSON)',
                    message: this.$t(`${idPanel}.actions.import.msg`),
                    allowedFileTypes: '.json,application/json',
                    replace: false,
                },
            }
        },
        mounted() {
            this.initialize();
        },
        computed: {
            actions() {
                return {
                    import: {
                        title: this.$t(`${this.idPanel}.actions.import.title`),
                        icon: 'fas fa-file-import',
                        active: () => {return true;},
                    },
                    add: {
                        title: this.$t(`${this.idPanel}.actions.add`),
                        icon: 'fas fa-plus',
                        active: () => {return true;},
                    },
                    export: {
                        title: this.$t(`${this.idPanel}.actions.export`),
                        icon: 'fas fa-file-export',
                        active: () => {return this.hasRecords;},
                    },
                    upload: {
                        title: this.$t(`${this.idPanel}.actions.upload.title`),
                        icon: 'fas fa-cloud-upload-alt',
                        active: () => {return this.$auth.check() && this.records.length>0;},
                    },
                    download: {
                        title: this.$t(`${this.idPanel}.actions.download.title`),
                        icon: 'fas fa-cloud-download-alt',
                        active: () => {return this.$auth.check();},
                    },
                };
            },
            activeActions() {
                const filtered = Object.entries(this.actions).filter(([key, value]) => value.active());
                return Object.fromEntries(filtered);
            },
            records() {
                return this.annotations && this.annotations.features ? this.annotations.features : [];
            },
            recordList() {
                return this.records instanceof Array ? this.records : [this.records];
            },
            hasRecords() {
                return this.records.length>0;
            },
            isRecordMode() {
                return !!this.selectedRecord;
            },
            selectedRecordId() {
                return this.selectedRecord ? this.selectedRecord.properties.id : null;
            },
        },
        methods: {
            initialize(){
                let _annotationsObject = this.defaultAnnotationsObject;
                if(this.annotationsObject) {
                    _annotationsObject = this.annotationsObject;
                }
                this.setAnnotations(_annotationsObject);
            },
            record(id) {
                return this.records.find(r => r.properties.id === id);
            },
            resetMap() {
            },
            onGeometryHighlight(params) {
                let {id, highlight} = params;
                this.updateHighlightStyle(id, highlight);
                this.renderRecords();
            },
            onSelectedRecord(id) {
                this.updateHighlightStyle(id, false);
                this.selectedRecord = this.record(id);
            },
            onUnselectedRecord() {
                this.updateHighlightStyle(this.selectedRecordId, false);
                this.selectedRecord = null;
            },
            onZoomToRecord(id) {
                const { properties = {}, features = [] } = this.record(id);
                let extent = this.getFeaturesExtent(features);
                if(extent) {
                    const _map = this.map;
                    if(_map) {
                        properties.visibility = true;
                        _map.zoomToExtent(_map.scaleExtent(extent, this.zoomToBoundsScale), this.zoomToBoundsDuration);
                    }
                }
            },
            applyAction(key, evt) {
                this.hideTooltip();
                switch(key) {
                    case 'import':
                        this.importRecords();
                        break;
                    case 'add':
                        this.addNewRecord();
                        break;
                    case 'export':
                        this.exportRecords();
                        break;
                    case 'upload':
                        this.uploadRecords();
                        break;
                    case 'download':
                        this.downloadRecords();
                        break;
                };
            },
            importRecords() {
                let modal = this.$refs.ModalImport;
                if(modal) {
                    modal.open({});
                }
            },
            addNewRecord() {
                const _map = this.map;
                const fid = this.generateId();
                let properties = {
                    id: fid,
                    title: null,
                    visibility: true,
                };

                let feature = {
                    type: 'FeatureCollection',
                    features: [],
                    properties,
                    style: {},
                    crs: _map ? this.createCRSObject(_map.getProjection()) : null,
                };
                feature.properties[this.temporaryProperty] = true;
                this.records.push(feature);
                this.onSelectedRecord(fid);
            },
            exportRecords(id=undefined, external=false) {
                this.exportAnnotations(this.annotations, id, external);
            },
            uploadRecords() {
                if(!this.$auth.check() || this.records.length==0) {
                    return;
                }
                this.$root.$emit('openConfirmation', {
                    id: null,
                    data: this.records,
                    text: `${this.idPanel}.actions.upload.msgConfirm`,
                    callback: (id, data) => {
                        this.uploadAnnotations(this.url.upload, data);
                    }
                });
            },
            downloadRecords() {
                if(!this.$auth.check()) {
                    return;
                }
                this.$root.$emit('openConfirmation', {
                    id: null,
                    data: this.records,
                    text: `${this.idPanel}.actions.download.msgConfirm`,
                    callback: (id, data) => {
                        this.downloadAnnotations(this.url.download, data)
                        .then(feats => {
                            let num = feats.length;
                            if(num>0) {
                                this.showMessage(`${this.idPanel}.actions.download.msgData`);
                            }else if(num==0) {
                                this.showWarning(`${this.idPanel}.actions.download.msgNoData`);
                            }
                        });
                    }
                });
            },
            onChangeRecord(data) {
                const { id, record = {}} = data;
                let rec = this.record(id);
                rec = Object.assign(rec, record);
                this.renderRecords();
            },
            onSaveRecord(record) {
                let rec = this.record(this.selectedRecordId);
                rec = Object.assign(rec, record);
                let properties = rec.properties;
                let id = properties.id;
                if(id) {
                    delete properties[this.temporaryProperty];
                }
                this.onUnselectedRecord();
                this.renderRecords();
            },
            onDeleteRecord(id) {
                let idx = this.records.findIndex(r => r.properties.id == id);
                if(idx > -1) {
                    this.records.splice(idx, 1);
                    this.onUnselectedRecord();
                    this.renderRecords();
                }
            },
            onExportRecord(params) {
                let {id, external} = params;
                this.exportRecords(id, external);
            },
            onBackRecord(record) {
                let rec = this.record(this.selectedRecordId);
                rec = Object.assign(rec, record);
                let properties = rec.properties;
                let id = properties.id;
                if(id && properties[this.temporaryProperty]) {
                    this.onDeleteRecord(id);
                }
                this.onUnselectedRecord();
                this.renderRecords();
            },
            updateHighlightStyle(id, highlight=false) {
                this.records.map(rec => {
                    if(!rec.style){
                        rec.style = {};
                    }
                    rec.style.highlight = rec.properties.id === id ? highlight : false;
                    if(rec.features) {
                        rec.features.map(feat => {
                            if(!feat.style){
                                feat.style = {};
                            }
                            feat.style.highlight = feat.properties.id === id ? highlight : false;
                        });
                    }
                });
            },
            async checkRecordSession() {
                let item = this.$refs['RecordItem'];
                if(item) {
                    return new Promise((resolve, reject) => {
                        let hasSession = this.selectedRecord && item.isRecordDirty;
                        if(hasSession) {
                            this.$root.$emit('openConfirmation', {
                                id: null,
                                data: this.recordSession,
                                text: this.txtConfirmLeaveSession,
                                callback: (id, data) => {
                                    item.closeRecord();
                                    resolve(true);
                                },
                            });
                        }else{
                            resolve(true);
                        }
                    });
                }else{
                    return true;
                }
            },
        },
        watch: {
            reset: {
                immediate: false,
                handler(value, oldValue) {
                    if(value){
                        this.resetMap();
                    }
                    if(!value && value != oldValue){
                        this.onUnselectedRecord();
                    }
                },
            },
        },

    }

</script>

<style scoped lang="scss">
    .btn .btn-image {
        width: 14px;
    }
</style>